import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface MoreIconPropsType {
    className?: string;
    onClick?: (e: React.SyntheticEvent) => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<MoreIconPropsType>`
    height: auto;
`;

export const MoreIcon = observer('MoreIcon', ({ className, onClick }: MoreIconPropsType): React.ReactElement => {
    return (
        <SvgElement
            className={className}
            onClick={onClick}
            width='24'
            height='24'
            fill='none'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M11 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM11 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM11 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z'
                stroke='#stroke'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </SvgElement>
    );
});
